<template>
  <div class="banner owl-carousel owl-theme">
    <div class="item" v-for="(banner, index) in banners" :key="index">
      <a href="javascript:">
        <img :src="banner.image" />
      </a>
    </div>
    <!-- <div class="item">
      <a href="javascript:">
        <img src="images/banner1.jpg" />
      </a>
    </div>
    <div class="item">
      <a href="javascript:">
        <img src="images/banner1.jpg" />
      </a>
    </div> -->
  </div>
</template>
<script>
import apis from "@/services/apis";

export default {
  data() {
    return {
      banners: [],
    };
  },
  methods: {
    getBanners() {
      return apis
        .getPortalBanners(this.$router.currentRoute.query.p)
        .then((response) => {
          console.log("my res ", response);
          this.banners = response;
        });
    },
  },
  mounted() {
    this.getBanners().then(function(banners) {
      // 整串banner放到這邊不然一切routing好像就消失了...= =...

      try {
        if ($(".banner").length > 0) {
          $.fn.shuffle = function() {
            var allElems = this.get(),
              getRandom = function(max) {
                return Math.floor(Math.random() * max);
              },
              shuffled = $.map(allElems, function() {
                var random = getRandom(allElems.length),
                  randEl = $(allElems[random]).clone(true)[0];
                allElems.splice(random, 1);
                return randEl;
              });
            this.each(function(i) {
              $(this).replaceWith($(shuffled[i]));
            });
            return $(shuffled);
          };

          var owl = $(".banner");
          // owl.on("initialize.owl.carousel", function(e) {
          //   owl.children().shuffle();
          // });

          owl.owlCarousel({
            items: 1,
            margin: 0,
            loop: false,
            lazyLoad: true,
            autoHeight: true,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            animateOut: "fadeOut",
            animateIn: "fadeIn",
            nav: true,
          });

          // 要觸發這一次先wordaround掉autoHeight 1px issue
          setTimeout(function() {
            owl.trigger('refresh.owl.carousel');
            // owl.trigger('next.owl.carousel');
          }, 500);
          
        }
      } catch (e) {
        console.log("owl failed " + e.stack);
      }
    });
  },
};
</script>
